jQuery( document ).ready( function ( $ ) {
	function TEXTTOSPEACH( thisInstance ) {
		console.log( '[JTF Gut Block - JS] jtf/jtf-tts v1.0' )
		this.instance = thisInstance
		this.getAudioFromServer()
	}

	TEXTTOSPEACH.prototype.getAudioFromServer = async function () {
		const self = this

		let fetchResponse = ""
		let fetchResponseData = ""

		const fetchRequest = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		}
		const playerId = $( self.instance ).find( ".jtf__tts" ).attr( 'data-playerid' )

		try {
			fetchResponse = await fetch(
				"/wp-json/jtf/v1/audio/retrievetts?playerid=" + playerId + "&auth=" + localObject.jtfRegKey,
				fetchRequest, // eslint-disable-line comma-dangle
			)
			//console.log( "status code: ", fetchResponse.status )

			if ( !fetchResponse.ok ) {
				console.log( fetchResponse )
				throw new Error( `Error! status: ${ fetchResponse.status }` )
			}
			fetchResponseData = await fetchResponse.json()

			if (
				'auth_fail' !== fetchResponseData &&
				'no_audio_data' !== fetchResponseData
			) {
				self.createAudioPlayer( fetchResponseData, playerId )
			}
		} catch ( error ) {
			console.log( error )
		}
	}

	TEXTTOSPEACH.prototype.createAudioPlayer = async function ( audioUrl, playerId ) {
		if ( audioUrl && playerId ) {
			const self = this
			$( self.instance ).find( 'audio' ).remove()

			let audioElement = document.createElement( "audio" )
			audioElement.controls = true
			audioElement.autoplay = false
			audioElement.src = audioUrl

			document.getElementById( 'jtf__tts--' + playerId ).appendChild( audioElement )

			audioElement.addEventListener( 'play', function ( e ) {
				//console.log( 'ttsAudioAction', 'Play: ' + e.target.src )
				dataLayer.push( {
					'event': 'ttsAudioEvent',
					'ttsAudioAction': 'play',
					'ttsAudioTitle': e.target.src,
				} )
			} )

			audioElement.addEventListener( 'ended', function ( e ) {
				//console.log( 'ttsAudioAction', 'Ended: ' + e.target.src )
				dataLayer.push( {
					'event': 'ttsAudioEvent',
					'ttsAudioAction': 'ended',
					'ttsAudioTitle': e.target.src,
				} )
			} )
		}
	}

	if ( $( '.wp-admin' ).length > 0 ) {
		setTimeout( function () {
			if ( $( '.wp-block-jtf-jtf-tts' ).length > 0 ) {
				$( '.wp-block.wp-block-jtf-jtf-tts' ).each(
					function () {
						new TEXTTOSPEACH( $( this ) )
					},
				)
			}
		}, 9000 )
	} else {
		if ( $( '.wp-block-jtf-jtf-tts' ).length > 0 ) {
			$( '.wp-block-jtf-jtf-tts' ).each(
				function () {
					new TEXTTOSPEACH( $( this ) )
				},
			)
		}
	}
} )
